export default "__VITE_ASSET__utRYxKAf__"